module.exports = __webpack_public_path__ + "static/media/call_status_on_hold_hover.00ffe596.svg";